import ChevronDownIcon from "@redotech/redo-icons/chevron-down.svg";
import ChevronUpIcon from "@redotech/redo-icons/chevron-up.svg";
import XIcon from "@redotech/redo-icons/x-close.svg";
import { openOrderDashboardPath } from "@redotech/redo-merchant-app-common/open-order-notifications";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoProgressBar } from "@redotech/redo-web/arbiter-components/progress-bar/redo-progress-bar";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

interface ProgressNotificationProps {
  dismiss: () => void;
  percentage: number;
  showDashboardLink?: boolean;
  subtext?: string;
  teamId: string;
  title: string;
}

export const ProgressNotification = memo(function ProgressNotification({
  dismiss,
  percentage,
  showDashboardLink = true,
  subtext,
  teamId,
  title,
}: ProgressNotificationProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <Flex dir="column" gap="none" w="xxs">
      <Flex align="center" justify="space-between" px="xl" py="md">
        <Text fontSize="sm" fontWeight="semibold">
          {title}
        </Text>
        <Flex align="center" gap="sm">
          <RedoButton
            IconTrailing={expanded ? ChevronUpIcon : ChevronDownIcon}
            onClick={() => setExpanded((current) => !current)}
            size="xs"
          />
          <RedoButton IconTrailing={XIcon} onClick={dismiss} size="xs" />
        </Flex>
      </Flex>
      {expanded && (
        <Flex dir="column" gap="sm" pb="md" px="xl" w="full">
          <RedoProgressBar
            labelStyle="tooltip"
            percentage={percentage}
            style="thin"
          />
          {subtext && (
            <Text fontSize="xs" textColor="secondary">
              {subtext}
            </Text>
          )}
          {showDashboardLink && (
            <RedoButton
              hierarchy="link"
              onClick={() => {
                const navigate = window.__redoOpenOrderNavigate;
                if (!navigate) {
                  return;
                }
                navigate(openOrderDashboardPath(teamId));
              }}
              size="xs"
              text="View on dashboard"
            />
          )}
        </Flex>
      )}
    </Flex>
  );
});
